// ============================================================================
// DNALogo — logo oficial do DNA Feel King (10/2026: letras brancas sobre o
// azul-marinho). Recorte com fundo transparente gerado da arte original
// (public/brand/dna-logo-original.webp):
//   tone="light" → letras brancas  (fundo marinho: sidebar, login, loader)
//   tone="dark"  → letras marinho  (fundo claro)
// Tamanho pela largura (px); a altura segue a proporção da arte (800×480).
// ============================================================================

import React from 'react';

const SRC = { light: '/brand/dna-logo-branco.png', dark: '/brand/dna-logo-navy.png' };

export default function DNALogo({ tone = 'light', width = 140, className = '', style }) {
  return (
    <img
      src={SRC[tone] || SRC.light}
      alt="DNA Feel King"
      width={width}
      height={Math.round(width * 0.6)}
      draggable={false}
      className={`select-none ${className}`}
      style={{ width, height: 'auto', ...style }}
    />
  );
}
